import { Flex, Image } from '@chakra-ui/react';
const UpgradeToPremiumBanner = ({ onBannerClick, isDisabled }) => {
  return (
    <Flex
      onClick={onBannerClick}
      borderRadius="12px"
      gap="5px"
      mt="24px"
      mb="20px"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="center"
      backgroundColor={isDisabled ? 'rgba(255,255,255,0.05)' : 'rgba(30, 147, 255, 1)'}
      boxShadow={isDisabled ? '0px 3px 0 0 rgba(0, 0, 0, 0.05)' : '0px 3px 0 0 rgba(255, 255, 255, 0.2)'}
      p="16px 16px 12px 16px"
      position="relative"
      overflow="hidden"
      color={isDisabled ? 'rgba(255,255,255,0.5)' : 'var(--chakra-colors-white)'}
      _before={
        isDisabled
          ? {}
          : {
              content: '""',
              position: 'absolute',
              top: '-100%',
              left: '-100%',
              width: '30px',
              height: '300%',
              background: 'rgba(255,255,255,0.2)',
              transform: 'rotate(-25deg)',
              animation: 'shimmer 1.5s 1s infinite ',
              zIndex: 1,
            }
      }
      sx={{
        '@keyframes shimmer': {
          '0%': { left: '-100px' },
          '100%': { left: 'calc(100% + 50px)' },
        },
      }}
    >
      <Flex
        fontSize="13px"
        fontWeight="400"
        fontFamily="'Fugaz One', cursive"
        textTransform="uppercase"
        textAlign="left"
        lineHeight="1.2"
      >
        UPGRADE TO PREMIUM
      </Flex>
      <Flex
        fontSize="17px"
        fontWeight="400"
        fontFamily="'Fugaz One', cursive"
        textTransform="uppercase"
        textAlign="left"
        lineHeight="1.2"
      >
        Auto Entry, Every Week
      </Flex>
      <Image
        src="images/raffle/prizes_full.webp"
        alt="prizes"
        w="100px"
        h="80px"
        position="absolute"
        bottom="-16px"
        right="-10px"
      />
    </Flex>
  );
};

export default UpgradeToPremiumBanner;
